import {
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { PlatformService } from '@shared/services/platform-service.service';
import { REQUEST } from '@shared/tokens/server.token';
import { environment } from 'src/environments/environment';

@Injectable()
export class CookieInterceptor implements HttpInterceptor {
  requestHeader: HttpHeaders;
  platformService = inject(PlatformService);
  req = this.platformService.run({
    server: () => inject(REQUEST, { optional: true }),
    browser: (): null => null,
  });

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    // return next.handle(request);

    const req = this.platformService.run({
      server: () => {
        if (!this.req?.cookies?.[environment.cookieName]) {
          return request;
        }

        const authReq = request.clone({
          setHeaders: {
            Cookie: `${environment.cookieName}=${
              this.req.cookies[environment.cookieName]
            }`,
          },
        });
        return authReq;
      },
      browser: () => request,
    });

    return next.handle(req);
  }
}
